import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPilone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPilone"><Path d="M2.5 20.5H21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 10.5H7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 14.5H17.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.4301 20.2546L14.4982 2.5H9.49823L4.56641 20.2546" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPilone;
